import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/video-body-editor"
    exact
    path="/consumer/features/video-body-editor"
    component={AsyncPage}
  />,
];
